// 业务流程
export const BUSINESS_FLOW = 1
// 表单流程
export const FORM_FLOW = 2
// 经典模版流程
export const TEMPLATE_FLOW = 3
